import React, { useEffect, useRef } from 'react';
import { Flex, theme } from 'antd';
import { Component, Field } from '../../../common/componentUtils';
// import { MandatoryFieldIndicator } from '../MandatoryFieldIndicator';

export interface MergeFieldComponentProps {
	component: Component;
	field: Field;
	scale: number;
	width: number;
}

export const MergeFieldComponent = ({
	component,
	field,
	scale,
	width,
}: MergeFieldComponentProps) => {
	const { token } = theme.useToken();
	// TODO : As of now Merge fields are optional so Manadatory icon is not required. Keeping this code once we have settings for merge fields
	// const { isRequired } = component;
	const { icon: Icon } = field;

	const label = component.value || component.name;

	const labelRef = useRef<HTMLSpanElement>(null);
	const initialOffSetWidthRef = useRef(0);
	const resizedOffSetWidthRef = useRef(0);

	useEffect(() => {
		if (component.value) {
			return;
		}
		const getShortName = (fullName: string, numberOfCharacters: number) => {
			return fullName.slice(0, numberOfCharacters);
		};

		const getResizedName = (num: number) => {
			const size = Math.max(num, 1);
			const labelParts = label.split('.');
			const getShortNameOrEmpty = (part: string) =>
				part ? getShortName(part, size) : '';

			if (labelParts.length === 1) {
				return getShortName(label, size);
			}

			const [dataSource, variableName, propertyName] = labelParts;
			const ds = getShortNameOrEmpty(dataSource);
			const varName = getShortNameOrEmpty(variableName);

			const parts = [ds, varName, propertyName].filter(Boolean);
			return parts.join('.');
		};

		const computeLabelWidth = () => {
			const parentElement = labelElement.parentElement;
			const { offsetWidth } = parentElement;
			return offsetWidth;
		};

		const labelElement = labelRef.current;

		if (labelElement) {
			if (!initialOffSetWidthRef.current) {
				initialOffSetWidthRef.current = computeLabelWidth();
			}

			if (Math.floor(width) <= Math.floor(initialOffSetWidthRef.current)) {
				const num = Math.floor((10 * width) / initialOffSetWidthRef.current);

				labelElement.textContent = getResizedName(num);

				const comp = Math.floor((resizedOffSetWidthRef.current / width) * 100);

				if (!resizedOffSetWidthRef.current || comp >= 99) {
					resizedOffSetWidthRef.current = computeLabelWidth();
				}
			} else {
				labelElement.textContent = `${label}`;
			}
		}
	}, [label, width, component.value]);

	return (
		<Flex gap={token.marginXS} style={{ transform: `scale(${scale})` }}>
			{component.value ? (
				''
			) : (
				<>
					<Icon size={16} />
					<span ref={labelRef} style={{ fontSize: '12px' }}>
						{resizedOffSetWidthRef.current < width && label}
					</span>
				</>
			)}
		</Flex>

		/* {isRequired  && !component.value && (
				<MandatoryFieldIndicator
					displayOutside={resizedOffSetWidthRef.current > width}
					scale={scale}
				/>
			)} */
	);
};
